import BookingFormMixin from '@/mixins/booking-form'
export default {
  mixins: [BookingFormMixin],
  data () {
    return {
      acceptedList: [
        {text: 'pending', value: 1},
        {text: 'accepted', value: 2},
        {text: 'refused', value: 3},
        {text: 'assign', value: 0}
      ],
      booqitUrl: 'https://booqitapp.com/?transportId='
    }
  },
  methods: {
    openBooqit (id) {
      if (id) {
        window.open(this.booqitUrl + id, '_blank');
      }
    },
    onChange (e) {
      this.distance[e.id] = e;
      this.form.fields[e.id] = e.value;
      if (e.id === 'clientId') {
        this.factuur = this.form.fields.factuur = e.data.factuur || this.factuur;
        this.$refs.pickupAddress.prefill(e.address);
      }
      if (e.id === 'driverId') {
        this.form.fields.price_driver = null;
        if (this.accepted != 1) {
          this.accepted = 1;
          this.changeAccepted(this.accepted, this.booking.id);
        }
      }
    },
    prefill (b) {
      console.log('-- prefill edit ---', b);
      // this.clientObj = this.clients.find(function (obj) { return obj.value === b.clientId; });
      var app = this;
      var price = 0;
      var arr = ['client', 'driver', 'destination'];
      app.initialized = false;

      arr.map(function (w) {
        var wObj = w + 'Obj';
        var wS = w + 's';
        var wId = w + 'Id';
        app[wObj] = app[wS].find(function (obj) { return obj.value === b[wId]; });
        if (app[wObj]) {
          app.distance[app[wObj].id] = app[wObj];
          app.form.fields[app[wObj].id] = app[wObj].value;
        } else {
          app[wS] = ['id: ' + b[wId] + ' not found']
        }
      })

      if (b.clientId) {
        if (b.pick_address) {
          this.setPickup(b.pick_address);
          this.$refs.pickupAddress.prefill(b.pick_address);
        } else {
          this.clientObj = this.clients.find(function (obj) { return obj.value === b.clientId; });
          this.$refs.pickupAddress.prefill(this.clientObj.address);
        }
      }

      price = this.booking.price;

      this.form.fields.ap_time = this.booking.ap_time;
      this.waittime = this.booking.ap_waittime;

      this.form.fields.ap_date = this.unformatDate(this.booking.ap_date);
      this.dateFormatted = this.booking.ap_date;
      this.form.fields.comment = this.booking.comment;
      this.form.fields.distance = this.distance_result = this.booking.json;
      this.form.fields.price = price
      this.form.fields.price_driver = this.booking.price_driver;
      this.form.fields.ticket_price = this.booking.ticket_price;
      this.form.fields.motive = this.booking.motive;
      this.form.fields.status = this.booking.status;
      this.accepted = this.booking.accepted;
      this.factuur = this.form.fields.factuur = this.booking.factuur;
      this.factuurDriver = this.booking.factuurDriver;
      this.creditDriver = this.booking.creditDriver;
      this.form.fields.creditAmount = this.booking.creditAmount;
      this.form.fields.creditReason = this.booking.creditReason;
      this.setType(this.booking.type);

      if (!this.booking.pick_time || this.booking.pick_time === '00:00:00') {
        this.updateApTime(this.booking.ap_time);
      }

      if (this.booking.mutualPatientID) {
        this.mutual = true;
        this.form.fields.mutualComment = this.booking.mutualComment;
        this.form.fields.mutualPatientID = this.booking.mutualPatientID;
        this.form.fields.mutualDistance = this.booking.mutualDistance;
        this.form.fields.noMutIntervention = this.booking.noMutIntervention || null;
        this.form.fields.certificateNeeded = this.booking.certificateNeeded || null;
        this.form.fields.certificateReceived = this.booking.certificateReceived || null;
        this.form.fields.min10km = this.booking.min10km;
        this.form.fields.plus10km = this.booking.plus10km;
        this.form.fields.mutualPatientAmount = this.booking.mutualPatientAmount;
        this.form.fields.mutualAmount = this.booking.mutualAmount;
        this.insuranceObj = app.insurances.find(function (obj) { return obj.value === app.booking.insuranceId; });
        this.form.fields.insuranceId = this.booking.insuranceId;
      }

      setTimeout(() => {
        app.initialized = true;
      }, 0);

    },
    init (v) {
      if (v) {
        console.log('Edit: do init:', this.booking);
        this.mutual = false;
        this.resetMutual();
        this.prefill(this.booking);
      }
    }
  }
}
